module.exports = __webpack_public_path__ + "static/media/carousel-img02.f720d117.png";